module.exports = __webpack_public_path__ + "static/media/usoEficiente.76fa1836.jpg";